import { Column, GridView, Griew, Response } from 'react-griew';
import ApiAppService from '../../service/api-app-service';
import loadDictionary from '../../plugins/locale/load-dictionary';
import { useEffect, useState } from 'react';
import i18n from '../../plugins/locale/i18n';
import Pasoonate from 'pasoonate';
import CreateApiAppWindow from './CreateApiAppWindow';
import EditApiAppWindow from './EditApiAppWindow';
import RefreshTokenWindow from './RefreshTokenWindow';


const apiAppService = new ApiAppService();
const griew = new Griew();

await loadDictionary('api-app-main-page');

function ApiAppMainPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenCreateWindow, setIsOpenCreateWindow] = useState(false);
  const [isOpenEditWindow, setIsOpenEditWindow] = useState(false);
  const [isOpenRefreshTokenWindow, setIsOpenRefreshTokenWindow] = useState(false);
  const [selectedApiAppId, setSelectedApiAppId] = useState(null);

  const reloadList = () => {
    setIsLoading(true);
    
    griew.refresh();
  };

  const handleOpenCreateWindow = (ApiAppId) => {
    setSelectedApiAppId(ApiAppId);
    setIsOpenCreateWindow(true);
  };

  const handleCloseCreateWindow = () => {
    setIsOpenCreateWindow(false);
    reloadList();
  };

  const handleOpenEditWindow = (ApiAppId) => {
    setSelectedApiAppId(ApiAppId);
    setIsOpenEditWindow(true);
  };

  const handleCloseEditWindow = () => {
    setIsOpenEditWindow(false);
    reloadList();
  };

  const handleOpenRefreshTokenWindow = (ApiAppId) => {
    setSelectedApiAppId(ApiAppId);
    setIsOpenRefreshTokenWindow(true);
  };

  const handleCloseRefreshTokenWindow = () => {
    setIsOpenRefreshTokenWindow(false);
    reloadList();
  };

  useEffect(() => {
    prepareGriew(setCount, setIsLoading, handleOpenCreateWindow, handleOpenEditWindow, handleOpenRefreshTokenWindow);
    reloadList();
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body p-3">
        <h4 className="page-title">{i18n.t("api-app-main-page.page_title")}</h4>
        <div className="header-content"></div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="mt-1 mb-3">{i18n.t("api-app-main-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className={"btn btn-sm btn-primary me-2 mb-2 "} type="button" onClick={handleOpenCreateWindow}>{i18n.t("api-app-main-page.create_button")}</button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
      </div>
      <CreateApiAppWindow key={`create-${Date.now()}`} isOpenWindow={isOpenCreateWindow} onCloseWindow={handleCloseCreateWindow} />
      <EditApiAppWindow key={`edit-${selectedApiAppId}`} isOpenWindow={isOpenEditWindow} onCloseWindow={handleCloseEditWindow} apiAppId={selectedApiAppId} />
      <RefreshTokenWindow key={`refresh-token-${selectedApiAppId}`} isOpenWindow={isOpenRefreshTokenWindow} onCloseWindow={handleCloseRefreshTokenWindow} apiAppId={selectedApiAppId} />
    </div>
  );

}

function prepareGriew(setCount, setIsLoading, handleOpenEditWindow, handleOpenRefreshTokenWindow) {
  const list = [
    {
      name: "id",
      caption: i18n.t("api-app-main-page.id"),
      schema: "ApiApp",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "app_name",
      caption: i18n.t("api-app-main-page.app_name"),
      schema: "ApiApp",
      type: Column.STRING,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: false,
    },
    {
      name: "token_prefix",
      caption: i18n.t("api-app-main-page.token_prefix"),
      schema: "ApiApp",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => {
        return (<div dir="ltr" className="text-left">{value}</div>);
      }
    },
    {
      name: "token_scopes",
      caption: i18n.t("api-app-main-page.token_scopes"),
      schema: "ApiApp",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: false,
    },
    {
      name: "token_expires_at",
      caption: i18n.t("api-app-main-page.token_expires_at"),
      schema: "ApiApp",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const expiersAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yyyy/MM/dd");
  
        return <span dir="ltr">{value === null ? '' : expiersAt}</span>;
      },
    },
    {
      name: "is_active",
      caption: i18n.t("api-app-main-page.is_active"),
      schema: "ApiApp",
      type: Column.BOOLEAN,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        return <span dir="ltr">{value ? 'فعال' : 'غیر فعال'}</span>;
      },
    },
    {
      name: "last_used_at",
      caption: i18n.t("api-app-main-page.last_used_at"),
      schema: "ApiApp",
      type: Column.DATETIME,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const lastUseAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yyyy/MM/dd");
  
        return <span dir="ltr">{value === null ? '' : lastUseAt}</span>;
      },
    },
    {
      name: "revoked_at",
      caption: i18n.t("api-app-main-page.revoked_at"),
      schema: "ApiApp",
      type: Column.DATETIME,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const revokedAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yyyy/MM/dd");
  
        return <span dir="ltr">{value === null ? '' : revokedAt}</span>;
      },
    },
    {
      name: "created_at",
      caption: i18n.t("api-app-main-page.created_at"),
      schema: "ApiApp",
      type: Column.DATETIME,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yyyy/MM/dd");
  
        return <span dir="ltr">{value === null ? '' : createdAt}</span>;
      },
    },
    {
      name: "updated_at",
      caption: i18n.t("api-app-main-page.updated_at"),
      schema: "ApiApp",
      type: Column.DATETIME,
      order: 5,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const updatedAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yyyy/MM/dd");
  
        return <span dir="ltr">{value === null ? '' : updatedAt}</span>;
      },
    },
    {
      name: "",
      caption: i18n.t("api-app-main-page.actions"),
      schema: "ApiApp",
      type: Column.STRING,
      order: 6,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, apiApp) => { 
        const editButton = <button type="button" className="btn btn-sm btn-light" onClick={() => { handleOpenEditWindow(apiApp.id) }}>{i18n.t("api-app-main-page.edit_button")}</button>;
        const refreshTokenButton = <button type="button" className="btn btn-sm btn-light" onClick={() => { handleOpenRefreshTokenWindow(apiApp.id) }}>{i18n.t("api-app-main-page.refresh_token_button")}</button>;  

        return (
          <>
          {editButton}
          {refreshTokenButton}          
          </>
        );
      }
    }
  ];
  const callback = (promis) => {
    promis.then(response => {
      const pagination = response.pagination;
      const data = response.data;

      const res = Response.make({
        data: data,
        pagination: {
          currentPage: pagination?.currentPage ?? 1,
          lastPage: pagination?.lastPage ?? 1,
          perPage: pagination?.perPage ?? 15,
          total: pagination?.total ?? 1,
          from: pagination?.from ?? 1,
          to: pagination?.to ?? 1,
        }
      });

      griew.refresh(res);

      setCount(pagination.total);

      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
    });
  };

  griew.localization.locale = 'fa';
  griew.columns.fromArray(list);
  griew.providers.default = 'function';
  griew.providers.getProvider().options = {
      function: (query) => apiAppService.gridview(query),
      callback: callback
  };
};

export default ApiAppMainPage;